<script>

import OperationsCarousel from "./User/OperationsCarousel";
import ContractsSubmit from "./Contracts/Submit.vue"
import ValidationIcon from "./ValidationIcon";
import Modal from "./Modal.vue";
import {axios} from '../mixins';

export default {
  name: "Tile.vue",

  components: {
    ValidationIcon,
    OperationsCarousel,
    ContractsSubmit,
    Modal,
  },

  mixins: [
    axios
  ],

  props: {
    mapboxToken: {
      type: String,
      required: false
    },
    esriToken: {
      type: String,
      required: false
    },
    // Indicator Options, needed for operations carousel
    options: {
      type: Object,
      required: false
    },
    defaultUnits: {
      type: Object,
      required: false
    },
    operationTypes: {
      type: Object,
      required: true,
    },
    requiredOperations: {
      type: Object,
      required: true
    },
    additionalityTypes: {
      type: Object,
      required: false,
      default: [],
    },
    // Loads all data as a prop, then mapped to allow reactivity
    data: {
      type: Object,
      required: true
    },
    copiedFieldYearData: {
      type: Object,
      required: false,
    },
    copiedFieldData: {
      type: Boolean,
      required: false,
    },
    userId: {
      type: Number,
      required: false,
    },
    farmId: {
      type: Number,
      required: false,
    },
    fieldId: {
      type: Number,
      required: false,
    },
    locked: {
      type: Boolean,
      required: false,
    }
  },

  data() {
    return {
      type: '',
      typeClasses: '',
      contentClasses: '',
      heading: '',
      subHeading: '',
      body: '',
      metrics: [],
      list: [],
      boundary: '',
      farmBoundary: '',
      fields: '',
      canEdit: '',
      copiedFieldYear: null,
      copiedField: null,
      cloningField: false,
      buttons: [],
      isValid: false,
      hasWarning: false,
      contractId: null,
      tableData: null,
      fsaInfo: null,
      fsaLoading: false,
      fsaDelete: false,
    }
  },

  created() {
    // Assign all values from data prop
    switch (this.data.type) {
      case 'text':
      case 'list':
      case 'metrics':
        this.typeClasses = 'col-span-12';
        break;
      case 'map':
      case 'mapOutline':
        this.typeClasses = 'col-span-12 lg:h-[30rem]';
        this.contentClasses = 'grid grid-cols-10 h-full';
        break;
      case 'carousel':
        this.typeClasses = 'col-span-12';
        break;
    }
    this.type = this.data.type;
    this.heading = this.data.heading;
    this.subHeading = this.data.subHeading;
    this.body = this.data.body;
    this.metrics = this.data.metrics;
    this.list = this.data.list;
    this.boundary = this.data.boundary;
    this.farmBoundary = this.data.layer;
    this.carouselData = this.data.carouselData;
    this.fields = this.data.fields;
    this.canEdit = this.data.canEdit;
    this.copiedFieldYear = this.copiedFieldYearData
    this.buttons = this.data.buttons;
    this.isValid = this.data.is_valid;
    this.hasWarning = this.data.has_warning
    this.contractId = this.data.contractId;
    this.tableData = this.data.tableData;

    this.copiedField = this.copiedFieldData
  },

  methods: {
    copyFieldYear(fieldYear) {
      this.copiedFieldYear = fieldYear
      this.$emit('copyFieldYear', fieldYear)
    },

    clearCopiedData() {
      this.copiedFieldYear = null;
      this.copiedField = false;
      this.$refs['operationsCarousel'].clearCopiedData()
      this.$emit('clearCopiedData')
    },

    copyField() {
      this.clearCopiedData()
      this.copiedField = this.fieldId;
      this.$emit('copyField')
    },

    pasteField() {
      this.cloningField = true;
      this.$emit('pasteField')
    },

    showResource(type, id) {
      this.$emit('show', type, id);
    },

    validateResource(resource) {
      let messages
      this.get('/validate/' + resource.type + '/' + resource.id).then((response) => {
        messages = response.data.errors;
        if (messages.length === 0) {
          messages = [
            ['Data is valid.']
          ]
        }

        let refResource = this.$refs['carousel-validation']
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)

      }).catch((errors) => {
        messages = [
          errors
        ]

        let refResource = this.$refs[resource.type + `-` + resource.id]
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)
      });
    },

    emitValidateResource(resource) {
      this.$emit('validateResource', resource);
    },

    numberFormat(value) {
      const numberFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
      return numberFormat.format(value);
    },

    openFsaModal() {
      this.fsaLoading = true;
      this.getFsaInfo(this.fieldId);
      this.$refs.fsaModal.open();
    },

    getFsaInfo() {
      this.get('fields/' + this.fieldId + '/fsa').then((response) => {
        if (response.data.errors) {
          this.alerts.recordErrors([response.data.message])
          this.fsaInfo = [];
          this.fsaLoading = false;
        } else {
          this.fsaInfo = response.data.data;
          this.fsaLoading = false;
        }
      })
    },

    setFsaInfo() {
      this.post('fields/' + this.fieldId + '/fsa', this.fsaInfo).then((response) => {
        if (response.errors) {
          this.alerts.recordErrors([response.errors])
        } else {
          this.$refs.fsaModal.close()
        }
      })
    },

    addFsaRow() {
      this.fsaInfo.push({
        'field_id' : this.fieldId,
        'fsa_farm' : null,
        'fsa_field' : null,
        'fsa_tract' : null,
        'fsa_acres' : null,
      });
    },
  },
}
</script>

<template>
  <div v-if="this.type === 'carousel'" :class="this.typeClasses" class="mx-2 my-1">
    <!-- CAROUSEL -->
    <div class="flex justify-between">
      <div class="rounded-t bg-primary tab-shadow font-semibold text-xl p-2 flex flex-col lg:flex-row justify-between">
        <ValidationIcon resourceType="fields"
                        :resourceId="this.fieldId"
                        :isValid="this.isValid"
                        :hasWarning="this.hasWarning"
                        :ref="`carousel-validation`"
                        @validate="this.validateResource({id: this.fieldId, type: 'fields'})">
          <template #is-valid="valid">
            <span v-show="this.isValid && !this.hasWarning" class="text-green">
              <i class="fas fa-check-circle"></i>
            </span>
            <span v-show="this.isValid && this.hasWarning" class="text-yellow-dark">
              <i class="fas fa-warning"></i>
            </span>
            <span v-show="!this.isValid" class="text-red">
              <i class="fas fa-circle-exclamation"></i>
            </span>
          </template>
        </ValidationIcon>

        <span class="pl-2">Operations</span>
      </div>

      <div class="flex flex-row justify-between py-2">
        <button class="button bg-primary mx-1 border-blue text-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                @click="this.openFsaModal">
          <span>
            <i class="fas fa-edit"></i> FSA Information
          </span>
        </button>

        <button v-if="this.copiedField && (this.copiedField !== this.fieldId)"
                class="button bg-primary mx-1 border-blue text-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                :disabled="this.cloningField"
                @click="pasteField">
          <span v-if="!this.cloningField">
            <i class="fas fa-paste"></i>
          </span>
          <span v-else>
            <i class="fas fa-spin fa-spinner-third"/>
          </span>
          <span class="pl-1">
            Paste Field
          </span>
        </button>

        <button v-if="this.copiedFieldYear || this.copiedField"
                class="button bg-primary ml-1 border-blue text-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                :disabled="this.cloningField"
                @click="clearCopiedData()">
          <span>
            <i class="fas fa-eraser"></i>
          </span>
          <span class="pl-1">
            Cancel Copy
          </span>
        </button>

        <button v-else
                class="button bg-primary ml-1 border-blue text-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                :disabled="this.cloningField"
                @click="copyField()">
          <span>
            <i class="fas fa-copy"></i>
          </span>
          <span class="pl-1">
            Copy Field
          </span>
        </button>
      </div>
    </div>

    <div class="bg-primary rounded-b rounded-tr p-2 tile-shadow">
      <div class="px-8">
        <OperationsCarousel ref="operationsCarousel"
                            :data="this.data"
                            :fields="this.fields"
                            :options="this.options"
                            :defaultUnits="this.defaultUnits"
                            :operation-types="this.operationTypes"
                            :required-operations="this.requiredOperations"
                            :additionality-types="this.additionalityTypes"
                            :mapbox-token="this.mapboxToken"
                            :esri-token="this.esriToken"
                            :copied-field-year="this.copiedFieldYear"
                            :copied-field="this.copiedFieldData"
                            :locked="this.locked"
                            @copyFieldYear="this.copyFieldYear"
                            @clearCopiedData="this.clearCopiedData"
                            @validateResource="this.emitValidateResource"
        >
        </OperationsCarousel>
      </div>
    </div>
  </div>

  <div v-else class="bg-primary rounded-lg p-2 mx-2 my-1 tile-shadow" :class="this.typeClasses">
    <!-- HEADINGS -->
    <div :class="this.contentClasses">
      <div class="flex flex-col overflow-auto pr-2 col-span-10 lg:col-span-4">
        <div class="flex justify-between">
          <div class="text-xl">{{ this.heading }}</div>
          <div v-if="this.canEdit" @click="this.$emit('openFieldForm')"
               class="button bg-primary border-blue text-blue text-sm hover:bg-grey-lightest focus:bg-grey-lighter">
            <span><i class="fas fa-pen-to-square"></i></span>
            <span class="pl-1">Edit Field</span>
          </div>
          <div v-if="this.contractId" class="flex flex-row mb-2">
            <a :href="`/contracts/` + this.contractId + `/export-limited`" target="_blank"
               class="px-6 py-1 my-auto rounded-sm text-white shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker font-semibold"><i
                class="fas fa-download mr-1"></i> Export
            </a>
          </div>
        </div>

        <div>{{ this.subHeading }}</div>

        <!-- BODY TEXT -->
        <div v-if="this.body" v-html="this.body" class="my-2"></div>

        <!-- OPTIONAL METRICS -->
        <div v-if="this.type === 'mapOutline' && this.metrics">
          <template v-for="item in this.metrics">
            <div>
              <div class="text-left text-lg font-bold p-2">{{ item.heading }}</div>
              <div class="text-center text-xl p-2">{{ item.value }}</div>
            </div>
          </template>
        </div>

        <!-- OPTIONAL BUTTONS -->
        <div v-if="this.buttons">
          <template v-for="button in this.buttons">
          </template>
        </div>
      </div>

      <div v-if="this.type === 'map' || this.type === 'mapOutline'" class="col-span-10 lg:col-span-6 h-96 lg:h-full">
        <map-box :token="this.mapboxToken"
                 :esri-token="this.esriToken"
                 :draw="false"
                 :height="`h-full`"
                 :source="this.boundary"
                 :source-name="this.heading"
                 :layer="this.farmBoundary"
                 :popups="true"
                 :outline="this.type === 'mapOutline'"
                 :farm-id="this.farmId"
                 @showField="showResource"
                 class="h-full"
        >
        </map-box>
      </div>
    </div>

    <!-- LIST -->
    <div v-if="this.list">
      <div class="w-full bg-secondary rounded-lg p-4 mb-4">
        <div class="h-96 lg:h-64 overflow-y-scroll">
          <table class="rounded-t-lg w-full relative">
            <thead>
            <tr class="text-left">
              <th class="bg-primary sticky top-0 px-4 py-3">Field</th>
              <th class="bg-primary sticky top-0 px-4 py-3">Size (ac)</th>
              <th class="bg-primary sticky top-0 px-4 py-3 z-2">Nitrogen Loss Prevented (lbs/ac/yr)
                <button v-on:mouseenter="tableData.nitrogenTooltip = true" v-on:mouseleave="tableData.nitrogenTooltip = false">
                  <div class="relative overflow-visible">
                    <div :class="tableData.nitrogenTooltip ? 'visible' : 'hidden'" class="w-96 bg-secondary p-2 border border-grey-light rounded absolute top-0 transform translate-y-10 -translate-x-1/2">
                      <span>Represents the total amount of nitrogen prevented from leaving enrolled fields measured in pounds per year</span>
                    </div>
                  </div>
                  <i class="fas fa-question-circle"></i>
                </button>
              </th>
              <th class="bg-primary sticky top-0 px-4 py-3 z-2">Phosphorous Loss Prevented (lbs/ac/yr)
                <button v-on:mouseenter="tableData.phosphorusTooltip = true" v-on:mouseleave="tableData.phosphorusTooltip = false">
                  <div class="relative overflow-visible">
                    <div :class="tableData.phosphorusTooltip ? 'visible' : 'hidden'" class="w-96 bg-secondary p-2 border border-grey-light rounded absolute top-0 transform translate-y-10 -translate-x-1/2">
                      <span>Represents the total amount of phosphorus prevented from leaving enrolled fields measured in pounds per year</span>
                    </div>
                  </div>
                  <i class="fas fa-question-circle"></i>
                </button>
              </th>
              <th class="bg-primary sticky top-0 px-4 py-3 z-2">Carbon (MT/ac/yr)
                <button v-on:mouseenter="tableData.carbonTooltip = true" v-on:mouseleave="tableData.carbonTooltip = false">
                  <div class="relative overflow-visible">
                    <div :class="tableData.carbonTooltip ? 'visible' : 'hidden'" class="w-96 bg-secondary p-2 border border-grey-light rounded absolute top-0 transform translate-y-10 -translate-x-1/2">
                      <span>Represents the total amount of soil carbon sequestration and nitrous oxide reductions measured in metric tonnes per year</span>
                    </div>
                  </div>
                  <i class="fas fa-question-circle"></i>
                </button>
              </th>
              <th class="bg-primary sticky top-0 px-4 py-3">Per Acre Payment</th>
              <th class="bg-primary sticky top-0 px-4 py-3">Total Payment</th>
              <th class="bg-primary sticky top-0 px-4 py-3">Verified</th>
            </tr>
            </thead>
            <template v-for="(field, index) in this.list">
              <tr v-if="field.is_included && field.hasOutcome" class="border-b border-grey-lighter hover:bg-grey-lightest" @click="setFieldIndex(index)">
                <td class="px-4 py-3">
                  {{ field.name }}
                </td>
                <td class="px-4 py-3">
                  {{ (field.size) }}
                </td>
                <td class="px-4 py-3">
                  {{ numberFormat(field.amounts[1] / field.size) }}
                </td>
                <td class="px-4 py-3">
                  {{ numberFormat(field.amounts[2] / field.size) }}
                </td>
                <td class="px-4 py-3">
                  {{ numberFormat(field.amounts[3] / field.size) }}
                </td>
                <td class="px-4 py-3">
                  ${{ numberFormat((tableData.allFieldsLimited ? (tableData.max * field.size) : field.limitedTotal) / field.size) }} <span v-show="field.max">**</span>
                </td>
                <td class="px-4 py-3">
                  ${{ tableData.allFieldsLimited ? numberFormat(tableData.max * field.size) : numberFormat(field.limitedTotal) }}
                </td>
                <td class="px-4 py-3 text-center text-xl">
                  <i :class="field.is_verified ? 'fas fa-check' : 'fas fa-times'"></i>
                </td>
              </tr>

              <tr v-else class="border-b border-grey-lighter hover:bg-grey-lightest">
                <td class="px-4 py-3">
                  {{ field.name }}
                </td>
                <td class="px-4 py-3">
                  {{ numberFormat(field.size) }}
                </td>
                <td colspan="5" class="px-4 py-3 text-center italic">
                  {{ field.is_included ? 'Awaiting Outcomes...' : 'Excluded' }}
                </td>
                <td class="px-4 py-3 text-center text-xl">
                  <i :class="field.is_verified ? 'fas fa-check' : 'fas fa-times'"></i>
                </td>
              </tr>
            </template>
            <tfoot>
            <tr class="bg-primary font-bold sticky bottom-0 hover:bg-grey-lightest">
              <td class="px-4 py-3">
                Totals
              </td>
              <td class="px-4 py-3">
                {{ numberFormat(tableData.size) }}
              </td>
              <td class="px-4 py-3">
                {{ numberFormat(tableData.amounts[1] / tableData.size) }}
              </td>
              <td class="px-4 py-3">
                {{ numberFormat(tableData.amounts[2] / tableData.size) }}
              </td>
              <td class="px-4 py-3">
                {{ numberFormat(tableData.amounts[3] / tableData.size) }}
              </td>
              <td class="px-4 py-3">
                ${{ numberFormat(tableData.total / tableData.size) }}{{ tableData.limitApplied === 'max' ? '*' : ''}}
              </td>
              <td class="px-4 py-3">
                ${{ numberFormat(tableData.total) }}{{ tableData.limitApplied === 'max' ? '*' : ''}}
              </td>
              <td class="px-4 py-3 text-center text-xl">
                <div v-if="tableData.allFieldsVerified">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else>
                  <i class="fas fa-times" title="Not all fields are verified."></i>
                </div>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
        <div v-if="tableData.limitApplied === 'max'" class="italic">
          * This contract is subject to a maximum of ${{ tableData.max }}/acre.
        </div>
        <div v-if="tableData.hasLimitedFields" class="italic">
          {{ tableData.allFieldsLimited ? `** All fields are limited due to the contract maximum of $` + tableData.max + `/acre.`
            : `** Field payment may be limited due to the contract maximum of $` + tableData.max +`/acre.` }}
        </div>
      </div>
    </div>

    <!-- METRICS -->
    <div v-if="this.type === 'metrics' && this.metrics" class="grid grid-cols-1 lg:grid-cols-4">
      <template v-for="item in this.metrics">
        <div class="flex flex-col bg-tertiary rounded-lg m-2">
          <div class="bg-secondary rounded-t-lg px-2 py-1 font-semibold flex justify-between items-center">
            {{ item.heading }}
            <div v-if="item.toolTip" v-on:mouseenter="item.showTip = true" v-on:mouseleave="item.showTip = false">
              <div class="relative" v-show="item.showTip">
                <div :class="item.translate"
                     class="z-10 w-96 bg-secondary p-2 border border-grey-light rounded absolute bottom-0 transform">
                  <span v-html="item.toolTip"></span>
                </div>
              </div>
              <i class="fas fa-question-circle"></i>
            </div>
          </div>
          <div class="flex h-full">
            <div class="text-lg m-auto p-2">
              {{ item.value }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

  <!-- FSA INFORMATION MODAL -->
  <Modal ref="fsaModal" v-if="this.type === 'carousel'">
    <div class="w-full sm:min-w-[40rem] p-2 overflow-auto h-96" aria-orientation="vertical" aria-labelledby="options-menu">
      <template v-if="this.fsaLoading" class="h-full">
        <div class="text-xl font-bold text-center my-auto">
          Loading...
        </div>
      </template>
      <template v-if="!this.fsaLoading">
        <div class="my-2 font-semibold text-xl">
          Edit FSA Information
        </div>
        <div v-for="fsa_row in this.fsaInfo" class="my-4 mx-2 flex justify-between items-center rounded">
          <div :class="fsa_row.delete ? 'p-2 m-2 flex flex-col bg-red bg-opacity-50 rounded' : 'p-2 m-2 flex flex-col'">
            <div class="grid grid-cols-2 w-full">
              <span class="my-auto">Farm ID</span><input v-model="fsa_row.fsa_farm" class="bg-secondary p-2 m-2" placeholder="Enter farm ID"/>
            </div>
            <div class="grid grid-cols-2 w-full">
              <span class="my-auto">Tract ID</span><input v-model="fsa_row.fsa_tract" class="bg-secondary p-2 m-2" placeholder="Enter Tract ID"/>
            </div>
            <div class="grid grid-cols-2 w-full">
              <span class="my-auto">Field ID</span><input v-model="fsa_row.fsa_field" class="bg-secondary p-2 m-2" placeholder="Enter Field ID"/>
            </div>
            <div class="grid grid-cols-2 w-full">
              <span class="my-auto">Acres</span><input v-model="fsa_row.fsa_acres" class="bg-secondary p-2 m-2" placeholder="Enter Acreage"/>
            </div>
          </div>
          <button v-if="!fsa_row.delete" class="p-2 font-semibold" @click="fsa_row.delete = true; this.fsaDelete = true">X</button>
          <button v-if="fsa_row.delete" class="p-2" @click="fsa_row.delete = false;">Restore</button>
        </div>
        <button class="p-2 my-2 bg-secondary text-center font-semibold" v-on:click="addFsaRow()">Add</button>
      </template>
    </div>
    <template #footer="{close}">
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button type="button"
                class="button bg-primary mx-1 px-2 bg-tertiary hover:bg-grey-lightest focus:bg-grey-lighter"
                v-on:click="close">
          Close
        </button>
      </span>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button class="button text-white font-bold bg-green hover:bg-green-dark focus:bg-green-darkerr"
                v-on:click="setFsaInfo()">
          Save
        </button>
      </span>
      <div v-if="this.fsaDelete" class="italic my-auto float-left flex-grow">
        Entries marked in red will be removed.
      </div>
    </template>
  </Modal>
</template>